import { Button } from "antd";
import React, { useState, FormEvent } from "react";
import "./ReportForm.scss";

type ReportFormProps = {
  setOpenModal: (open: boolean) => void;
  feedbackMode?: boolean;
};

const ReportForm: React.FC<ReportFormProps> = ({
  setOpenModal,
  feedbackMode,
}) => {
  const [email, setEmail] = useState<string>("");
  const [subject, setSubject] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const [statusMessage, setStatusMessage] = useState<{
    type: "success" | "error";
    text: string;
  } | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setLoading(true);
    setStatusMessage(null);

    // Get the current analysis URL
    const analysisUrl = window.location.href;

    const formData = {
      access_key: "ac480be8-2e35-4600-8a97-742b603782b3",
      subject: subject || "Issue Report",
      message,
      email,
      analysis_url: analysisUrl,
    };

    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await res.json();

      if (result.success) {
        console.log("Success", result);
        setStatusMessage({
          type: "success",
          text: "Thank you! Your issue has been reported.",
        });
        // Clear form after successful submission
        setEmail("");
        setSubject("");
        setMessage("");
        // Close modal after a short delay
        setTimeout(() => {
          setOpenModal(false);
        }, 2000);
      } else {
        console.error("Error:", result);
        setStatusMessage({
          type: "error",
          text: result.message || "Submission failed. Please try again.",
        });
      }
    } catch (error) {
      console.error("Error:", error);
      setStatusMessage({
        type: "error",
        text: "There was an error submitting your report. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <span className="frm-tit">
        {feedbackMode ? "We value your feedback!" : "Report an Issue"}
      </span>

      <form onSubmit={handleSubmit} className="report-form">
        <input
          aria-label="Email"
          placeholder="Your email address"
          type="email"
          onChange={(e) => setEmail(e.target.value)}
          value={email}
          className="form-input"
          required
        />

        <input
          aria-label="Subject"
          placeholder={feedbackMode ? "Feedback subject" : "Issue subject"}
          type="text"
          onChange={(e) => setSubject(e.target.value)}
          value={subject}
          className="form-input"
        />

        <textarea
          aria-label="Message"
          placeholder={
            feedbackMode
              ? "Let us know your thoughts, suggestions, or issues..."
              : "Describe the issue you encountered..."
          }
          required
          onChange={(e) => setMessage(e.target.value)}
          value={message}
          className="form-textarea"
          rows={5}
        />

        {statusMessage && (
          <div className={`status-message status-${statusMessage.type}`}>
            {statusMessage.text}
          </div>
        )}

        <Button
          type="primary"
          htmlType="submit"
          loading={loading}
          block
          style={{
            background: "linear-gradient(90deg, #68BFE5 0%, #0099EF 100%)",
            color: "#fff",
            border: "none",
            fontWeight: 700,
            fontSize: 16,
            padding: "12px 0",
            borderRadius: 8,
            boxShadow: "0 2px 8px rgba(0,179,255,0.08)",
            marginTop: 8,
          }}
        >
          {feedbackMode ? "Send Feedback" : "Submit Report"}
        </Button>
      </form>
    </>
  );
};

export default ReportForm;
